import React from 'react';
import { Line } from 'react-chartjs-2';
import { CalculationResponse, PensionInputs, IndexInputs } from '../Interfaces';
import { generateChartData, getChartOptions } from '../Helpers/chartHelper';

interface ComparisonChartProps {
  results: CalculationResponse;
  pensionInputs: PensionInputs;
  indexInputs: IndexInputs;
  inflationRate: number;
}

export const ComparisonChart: React.FC<ComparisonChartProps> = ({
  results,
  pensionInputs,
  indexInputs,
  inflationRate,
}) => {
  const startAge = Math.min(pensionInputs.startAge, indexInputs.startAge);
  const chartData = generateChartData(results, pensionInputs, indexInputs);
  const chartOptions = getChartOptions(inflationRate, startAge);

  if (!chartData) return null;

  return (
    <div className="chart-container">
      <Line data={chartData} options={chartOptions} />
    </div>
  );
};